
import { observable, action, runInAction } from "mobx";
import * as API from '../../../../api/m/teams'
import * as qysAPI from '../../../../api/qysCheck'
import { Dialog, MDialog, Spin } from "@weapp/ui";
import { TenantListType } from "../../../main/createTeams/type";
import { clearCookieByName, clearTeamsCookie, inApp, isIpHost, mainHost, setCookie, setPomCookie } from "../../../../utils";
import { getLabel, weappSDK } from "@weapp/utils";
import { res } from "@weapp/ui/lib/components/secret-select/utils/mock";
import { layoutPublicUrl } from "../../../../constants";

const { toast, prompt } = MDialog;
const passportWeb = window.TEAMS.passportUrl;
export class MTeamsStore {
    @observable teamsList = []
    @observable applyInvite: any = [];
    @observable tenantList: TenantListType[] = [];
    @observable dialogadviceVisible = false;
    @observable changeLoading = false;
    @observable createLoading = false;
    @observable loading = true;
    @observable keywords = '';
    @observable qysCheckAuthUrl: string = '';
    @observable qysFrameShown: boolean = false;
    @observable onQysChecking: boolean = false;
    app_qysQueryParams: any;
    currentTenantObj: any;
    qysTimer: any = null;
    loadingTimer: any = null

    @action
    init = () => {
        if (inApp()) {
            weappSDK.checkApi('listenVisible').then(() => {
                weappSDK.exec('listenVisible', {
                    success: () => { },
                    fail: () => { },
                    callback: (res: any) => {
                        if (res?.visible && this.onQysChecking) {
                            this.appQysCheckOnece(this.app_qysQueryParams)
                        }
                    },
                })
            })
        }
    }

    @action
    getTeamsData = (callback?: (teamsList: any) => void) => {
        this.loading = true
        API.getTeams()
            .then((result: any) => {
                runInAction(() => {
                    this.loading = false
                    this.teamsList = result.data;
                    callback?.(result.data);
                });
            })
            .catch((error: any) => {
                console.log(error);
                runInAction(() => {
                    this.loading = false
                })
            });
    }
    @action
    getList = () => {
        API.queryTenant({ keywords: this.keywords })
            .then((result: any) => {
                runInAction(() => {
                    if (result) {
                        this.applyInvite = result.applyInvite;
                        this.tenantList = result.tenantList;
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
    @action
    applyTenant = (data: any, callback?: () => void) => {
        API.applyTenant(data)
            .then((result: any) => {
                runInAction(() => {
                    if (result && result.message) {
                        toast({
                            content: result.message,
                        });
                    } else {
                        this.getList();
                        callback && callback();
                    }
                });
            })
            .catch((error) => {
                toast({
                    content: getLabel('61289', '操作失败'),
                });
                console.log(error);
            });
    };

    @action
    recoverTenant = (data: any, callback?: () => void) => {
        API.applyTenant(data)
            .then((result: any) => {
                if (result) {
                    toast({
                        content: getLabel('254889', '组织已成功恢复'),
                    });
                    this.getList();
                    callback && callback();
                }
            })
            .catch((error) => {
                toast({
                    content: getLabel('61289', '操作失败'),
                });
                console.log(error);
            });
    };

    @action
    cancelApply = (data: any) => {
        API.cancleApply(data)
            .then((result: any) => {
                runInAction(() => {
                    this.getList();
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
    @action
    createTeams = (data: any, callback?: any) => {

        // this.props.mobTeamsStore?.createTeams({ tenantName: tenantName, adminMobile: adminMobile, email: email, telephone: telephone, address: address }, () => {
        //     this.setState({ createLoading: false })
        // })
        runInAction(() => {
            this.createLoading = true;
        });
        API.createTeams(data).then((result: any) => {
            runInAction(() => {
                if (result.newEmpId) {
                    // window.location.href = window.TEAMS.passportUrl + '/changeTenantNew/' + result.newEmpId
                    this.doChangeTenant(result.newEmpId);
                    this.createLoading = false;

                } else {
                    this.createLoading = false;
                    callback && callback()
                    toast({
                        content: result.message,
                    });
                }
                this.createLoading = false;
            });
        }).catch((error) => {
            runInAction(() => {
                this.createLoading = false;
            });
            callback && callback()
            console.log(error);
        });
    };

    @action
    changeQysFrameShown = (visible: boolean) => {
        this.qysFrameShown = visible;
        if (!visible) {
            this.onQysChecking = false;
        }
    }

    @action
    changeQysCheckAuthUrl = (value: string) => {
        this.qysCheckAuthUrl = value;
    }
    @action
    checkLoginCallback = (tenant = this.currentTenantObj) => {
        // 校验IP黑白名单
        this.checkIpEnable(tenant, () => {
            // 校验登录方式拦截
            this.checkLoginType(tenant, () => {
                this.checkSSOAndChangeTenant(tenant);
            })
        })
    }

    @action
    changeTeam = (tenant: any) => {//更改团队
        try {
            this.loading = true
            this.loadingTimer = setTimeout(() => { //保底：防止切换团队被校验拦截时未将loading置为flase导致长时间加载(主要怕有遗漏的)
                runInAction(() => {
                    this.loading = false
                })
                clearTimeout(this.loadingTimer)
            }, 5000);
            this.currentTenantObj = tenant;
            //校验契约锁
            this.checkQys(tenant)
        } catch (error) {
            console.log("errror", error);
            runInAction(() => {
                this.loading = false
                clearTimeout(this.loadingTimer)
            })

        }
    }
    /**
       *
       * @param params 轮询请求etoken判断登录状态
       */
    @action
    QysQrcodePolling = (params: any) => {
        this.qysTimer = setInterval(() => {
            this.appQysCheckOnece(params);
        }, 1000);
    }
    @action
    appQysCheckOnece = (params: any) => {
        qysAPI.checkQysQrStatus(params).then((result: any) => {
            if (result?.data?.qysAccess) {
                clearInterval(this.qysTimer);
                this.checkLoginCallback()
            }
        });
    }

    @action
    checkQys = (tenant: any) => {
        const { employeeId, tenantKey } = tenant;
        const qysParams = {
            targetEmployeeId: employeeId,
            targetTenantKey: tenantKey,
            operateType: 'pcChangeTenant'
        }
        qysAPI.checkQys(qysParams).then((result: any) => {
            if (result.data && typeof result.data === 'object' && result.data.qysCheckAuthUrl) {
                runInAction(() => {

                    this.onQysChecking = true;
                    this.app_qysQueryParams = {
                        tenantKey: result.data?.tenantKey,
                        qysCheckAuthId: result.data?.qysCheckAuthId,
                        operateType: 'pcChangeTenant'
                    }
                    if (inApp()) {
                        console.debug('inapp')
                        weappSDK.customSDK.invoke("openLink", {
                            url: result.data.qysCheckAuthUrl,
                            openType: 2,
                            success: () => {
                            }
                        });
                    } else {
                        this.changeQysCheckAuthUrl(result.data.qysCheckAuthUrl);
                        this.changeQysFrameShown(true);
                        //契约锁校验
                        this.QysQrcodePolling(this.app_qysQueryParams)
                    }
                })

            } else {
                this.checkLoginCallback();
            }
        })
    }

    @action
    checkIpEnable = (tenant: any, callback: Function) => {
        const { employeeId, tenantKey } = tenant;
        // 校验IP黑白名单
        API.changeTenantPermission({ employeeId }).then((data: any) => {
            if (data && data.actionMsgFlag == 'true') {
                toast({
                    content: data.message,
                });
                runInAction(() => {
                    this.changeLoading = false;
                    this.loading = false
                    clearTimeout(this.loadingTimer)
                });
                return;
            }
            callback();
        });
    }

    // 校验登录方式拦截
    @action
    checkLoginType = (tenant: any, callback: Function) => {
        const { employeeId, tenantKey } = tenant;
        API.checkChangeTenantLoginType({ empId: employeeId, loginType: inApp() ? 'app_account' : 'h5_account' }).then((res: any) => {
            runInAction(() => {
                if (res && res.code == -1) {
                    this.loading = false
                    clearTimeout(this.loadingTimer)
                    toast({
                        content: res.message,
                    });
                    return;
                }
                callback();
            });
        });
    }

    @action
    checkSSOAndChangeTenant = (tenant: any) => {
        const { employeeId, tenantKey, uuid = '', tenantName = '' } = tenant;
        API.ssoCheck({
            targetEmployeeId: employeeId,
            targetTenantKey: tenantKey,
            eteamsid: window.ETEAMSID
        }).then((res: any) => {
            runInAction(() => {
                this.loading = false
                clearTimeout(this.loadingTimer)
                // 跨系统单点
                if (res?.data?.changeInfo) {
                    if (inApp()) {
                        weappSDK.customSDK.invoke("reload", {
                            loginkey: "", //string 类型。必填，身份认证标识，即eteamsid
                            teamName: tenantName,//团队名称，用于区别是否跨团队
                            tenantid: tenantKey, //string 类型。必填，租户id，区分租户
                            cid: uuid, //string 类型。非必填，消息服务中的团队标识cid
                            userid: employeeId, //string 类型。必填，用户在租户下的ID，即employeeId
                            langid: "", //非必填，语言标识，7、8、9等
                            clearCache: 0, //是否要清除缓存，1表示清除，0表示不清除，默认为0
                            success: (res: any) => {
                                //TODO 登录处理
                            }
                        })
                    } else {
                        window.ePassport?.clearCookies();
                        window.location.href = `${res.data.targetDomain}/papi/passport/changeTenant/ssoChange?service=${encodeURIComponent(res.data.targetDomain)}&changeInfo=${encodeURIComponent(res.data.changeInfo)}`
                    }
                } else {
                    this.doChangeTenant(employeeId);
                }
            })

        }).catch(() => {
            this.doChangeTenant(employeeId);
        })
    }
    @action
    changeDialogadviceVisible = () => {
        // clearTeamsCookie();
        this.dialogadviceVisible = !this.dialogadviceVisible
    }

    backToAppLogin = () => {
        weappSDK.customSDK.invoke("logout", {
            success: (res: any) => { },
        });
    }

    @action
    doChangeTenant = (employeeId: string) => {
        runInAction(() => {
            if (inApp()) {
                weappSDK.customSDK.invoke("getClientInfo", {
                    success: (res: any) => {
                        let appParams = {
                            imei: res.deviceId,
                            version: res.osVersion,
                            secondImei: res.deviceId2,
                            adviceInfo: res.clientModel,
                            ETEAMSID: window.ETEAMSID,
                            employeeId: employeeId
                        }
                        API.changeTenant(appParams).then((result: any) => {
                            if ("200" == result.code && "ok" == result.msg) {
                                let host = window.location.hostname;
                                let domain = host.substr(host.indexOf(".") + 1);
                                clearTeamsCookie();
                                // weappSDK.invoke("clearWebCaches", {
                                //     success: (res:any)=> {}
                                // });
                                if (isIpHost()) {
                                    domain = host;
                                }
                                API.clearCookie('ETEAMSID').then(() => {
                                    setPomCookie('ETEAMSID', result.data.loginkey, domain);
                                    setCookie('ETEAMSID', result.data.loginkey);
                                    // toast({type:"info", content:"reload"})
                                    weappSDK.customSDK.invoke("reload", {
                                        loginkey: result.data.loginkey, //string 类型。必填，身份认证标识，即eteamsid
                                        tenantid: result.data.tenantid, //string 类型。必填，租户id，区分租户
                                        cid: result.data.cid, //string 类型。非必填，消息服务中的团队标识cid
                                        userid: result.data.employeeid, //string 类型。必填，用户在租户下的ID，即employeeId
                                        langid: "", //非必填，语言标识，7、8、9等
                                        clearCache: 0, //是否要清除缓存，1表示清除，0表示不清除，默认为0
                                        success: (res: any) => {
                                            //TODO 登录处理
                                            // toast({type:"info", content:JSON.stringify(res)})
                                        }
                                    })
                                })
                            } else if ("400" == result.code && result.bindAdviceFlag == true) {
                                this.changeDialogadviceVisible();
                            } else if ("400" == result.code) {
                                weappSDK.customSDK.invoke("getLastLoginInfo", {
                                    success: function (result: any) {
                                        //res数据内容
                                        let appParams = {
                                            imei: res.deviceId,
                                            version: res.osVersion,
                                            secondImei: res.deviceId2,
                                            adviceInfo: res.clientModel,
                                            username: result.username,
                                            password: result.password
                                        }
                                        //tgt过期，自动登录一次
                                        API.login(appParams).then((result: any) => {
                                            if ("true" == result.succeed && (result.ETEAMSID != null && result.ETEAMSID != "")) {
                                                let host = window.location.hostname;
                                                let domain = host.substr(host.indexOf(".") + 1);
                                                clearTeamsCookie();
                                                if (isIpHost()) {
                                                    domain = host;
                                                }
                                                API.clearCookie('ETEAMSID').then(() => {
                                                    setPomCookie('ETEAMSID', result.data.loginkey, domain);
                                                    setCookie('ETEAMSID', result.ETEAMSID);
                                                    //切换团队
                                                    let appChangeParams = {
                                                        imei: res.deviceId,
                                                        version: res.osVersion,
                                                        secondImei: res.deviceId2,
                                                        adviceInfo: res.clientModel,
                                                        ETEAMSID: result.ETEAMSID,
                                                        employeeId: result.employeeId
                                                    }
                                                    API.changeTenant(appParams).then((result1: any) => {
                                                        if ("200" == result.code && "ok" == result1.msg) {
                                                            let host = window.location.hostname;
                                                            let domain = host.substr(host.indexOf(".") + 1);
                                                            // weappSDK.invoke("clearWebCaches", {
                                                            //     success: (res:any)=> {}
                                                            // });
                                                            if (isIpHost()) {
                                                                domain = host;
                                                            }
                                                            setPomCookie('ETEAMSID', result.data.loginkey, domain);
                                                            setCookie('ETEAMSID', result.data.loginkey);
                                                            weappSDK.customSDK.invoke("reload", {
                                                                loginkey: result1.data.loginkey, //string 类型。必填，身份认证标识，即eteamsid
                                                                tenantid: result1.data.tenantid, //string 类型。必填，租户id，区分租户
                                                                cid: result1.data.cid, //string 类型。非必填，消息服务中的团队标识cid
                                                                userid: result1.data.employeeid, //string 类型。必填，用户在租户下的ID，即employeeId
                                                                langid: "", //非必填，语言标识，7、8、9等
                                                                clearCache: 0, //是否要清除缓存，1表示清除，0表示不清除，默认为0
                                                                success: (res: any) => {
                                                                    //TODO 登录处理
                                                                }
                                                            })
                                                        }
                                                    });
                                                })
                                            } else {
                                                toast({
                                                    content: result.message,
                                                    mask: false,
                                                    delay: 2000
                                                });
                                                // if (result.code === '10007') {
                                                //     prompt({
                                                //         mask: true,
                                                //         // maskClosable: true,
                                                //         prompt: false,
                                                //         message: getLabel('91358', 'APP会话超时，请重新登录'),
                                                //         onClose: () => { },
                                                //         onOk: () => { this.backToAppLogin() },
                                                //         okText: getLabel('69025', '确认'),
                                                //         cancelText: getLabel('69026', '取消')
                                                //     })
                                                // }
                                            }
                                        });
                                    }
                                })
                            } else {
                                toast({
                                    content: result.msg,
                                    mask: false,
                                    delay: 2000
                                });
                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                    }
                })
            } else {
                let appParams = {
                    ETEAMSID: window.ETEAMSID,
                    employeeId: employeeId
                }
                API.changeTenant(appParams).then((result: any) => {
                    if ("200" == result.code && "ok" == result.msg) {
                        let host = window.location.hostname;
                        // let domain = host.substr(host.indexOf(".") + 1);
                        let domain = host.substr(host.indexOf(".") + 1);
                        clearTeamsCookie();
                        if (isIpHost()) {
                            domain = host;
                        }
                        API.clearCookie('ETEAMSID').then(() => {
                            setPomCookie('ETEAMSID', result.data.loginkey, domain);
                            setCookie('ETEAMSID', result.data.loginkey);
                            window.location.href = `${mainHost()}${window.TEAMS?.loginAccountInfo?.sysLoginRedirectPath || layoutPublicUrl}`;
                        })
                    } else {
                        if (result.msg) {
                            toast({
                                content: result.msg,
                                mask: false,
                                delay: 2000
                            });
                        } else if (result.actionMsg && result.actionMsg.message) {
                            toast({
                                content: result.actionMsg.message,
                                mask: false,
                                delay: 2000
                            });
                        }

                    }
                }).catch((error) => {
                    runInAction(() => {
                        console.log(error);
                    });
                });
            }
        });
    }


    @action
    adviceEeamsIdBind = (obj: any) => {
        API.adviceEeamsIdBind(obj).then((result: any) => {
            runInAction(() => {
                if ("200" == result.code) {
                    this.dialogadviceVisible = false;
                    this.doChangeTenant(obj.employeeId);
                } else {
                    this.dialogadviceVisible = false;
                    if (result.msg) {
                        toast({
                            content: result.msg,
                            mask: false,
                            delay: 2000
                        });
                    }
                }
            })

        })
            .catch((error) => {
                console.log(error);
            });
    };
    @action
    setKeywords = (val: string) => {
        this.keywords = val
    }
}



const instance = new MTeamsStore();

export default instance;
